export default __webpack_public_path__ + "static/media/Archdeacon's Bracers of the Sacred Mountain.6bfe6810.jpg";